import Vue from 'vue';
import VueRouter, { NavigationGuardNext, Route, RouteConfig } from 'vue-router';
import loginAndRegister from '@/router/loginAndRegister';
import preLogin from '@/views/login/preLogin/preLogin.vue';
import representation from '@/router/representation';
import Home from '../views/Home/Home.vue';
import NotFound from '../views/NotFound/NotFound.vue';
import analysis from './studyAnalysis';
import addActivity from './addActivity';
import onlineLive from './onlineLive';
import courseHome from './courseHome';
import score from './score';
import testing from './testing';
import KtpInfo from '@/views/Home/ktpInfo/ktpInfo.vue';
import KtpCourse from '@/views/Home/ktpCourse/ktpCourse.vue';
import KtpMessage from '@/views/Home/ktpMessage/ktpMessage.vue';
import ktpMy from '@/views/Home/ktpMy/ktpMy.vue';
import TodoList from '@/views/todoList/todoList.vue';
import courseList from '@/router/courseList';
import member from './member';
import course from './course';
import homework from './homework';
import advancedProblem from './advancedProblem';
import my from './my';
import message from './message';
import checkIn from './checkIn';
import conference from './conference';
import interactiveAnswers from './interactiveAnswers';
import ktpActivity from './ktpActivity';
import ktpStudentHome from './ktpStudentHome';
import teachingAndResearchOffice from './virtualTeachingAndResearchOffice';
import casestudy from './casestudy';
import { objCookie } from '@/utils/common';
import { getUrlQueryUseHash } from '@/utils/utils';
import { getCourseHeaderInfo, postGetCourseUserInfo } from '@/apis/courseHome/index';
import store from '@/store';
import i18n from '@/lang';
import remotecontroller from './remotecontroller';
import Funny from '@/views/Funny/funny.vue';
import paiAgent from './pai';
import { Dialog, Toast } from 'vant'
import { visitCourse } from '@/apis/courseList/courseList';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/preLogin',
    name: i18n.t('Home.登录中') as string,
    component: preLogin
  },
  {
    path: '/todoLogin',
    name: i18n.t('Home.正在跳转中') as string,
    component: () => import('@/views/login/todoLogin/index.vue')
  },
  {
    path: '/',
    name: 'home',
    component: Home,
    children: [
      {
        path: '/teachingAndResearchOffice',
        name: 'teachingAndResearchOffice',
        component: () => import(/* webpackChunkName: "TeachingAndResearchOffice" */ '@/views/virtualTeachingAndResearchOffice/Home/index.vue')
      },
      {
        path: '/ktpStudentHome',
        name: 'ktpStudentHome',
        component: () => import(/* webpackChunkName: "ktpStudentHome" */ '@/views/Home/ktpStudentHome/index.vue')
      },
      {
        path: 'ktpInfo',
        name: 'ktpInfo',
        component: KtpInfo
      },
      {
        path: 'ktpCourse',
        name: 'ktpCourse',
        component: KtpCourse
      },
      {
        path: 'ktpMessage',
        name: i18n.t('Home.私信') as string,
        component: KtpMessage
      },
      {
        path: 'ktpMy',
        name: 'ktpMy',
        component: ktpMy
      },
      {
        path: '/todoList',
        name: i18n.t('Home.待办事项') as string,
        component: TodoList
      }
    ]
  },

  {
    path: '/index',
    name: '/index',
    component: {}
  },
  {
    path: '/courseDoor',
    name: '课程门户',
    component: () => import(/* webpackChunkName: "courseDoor" */ '@/views/CourseDoor/index.vue')
  },
  {
    path: '/NotFound',
    name: 'NotFound',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: NotFound
  },
  ...my,
  ...addActivity,
  ...analysis, // 学情分析
  ...onlineLive,
  ...loginAndRegister,
  ...representation, // 表现管理
  ...score, // 成绩模块
  ...testing, // 测试模块
  ...courseList, // 课程列表模块 郎伟成写
  ...courseHome, // 课程首页
  ...member, // 成员
  ...course, // 课堂
  ...homework, // 作业
  ...advancedProblem, // 高级问题作业
  ...message, // message
  ...checkIn, // 考勤
  ...interactiveAnswers, // 互动答题
  ...conference, // 腾讯会议
  ...ktpActivity, //课堂派活动及临时页面路由
  ...teachingAndResearchOffice, //虚拟教研室
  ...ktpStudentHome, //学生学习课程(畅学卡)
  ...remotecontroller, //遥控器
  ...casestudy, //案例学习
  ...paiAgent, //Pai智能体
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to: Route, from: Route, next: NavigationGuardNext<Vue>) => {
  if (sessionStorage.getItem('courseId')) {
    // 路由变化时，若有课程id，说明进入了课堂，此时判断是否开启了ws
    if (window.wsAppModule && window.wsAppModule.status === 3) {
      window.wsAppModule.startInstance();
    }
  }
  //这里处理一下权限拦截
  //判断权限，如果有courseid值和courseRole值，则进行权限的拦截
  let courseid = getUrlQueryUseHash('courseId',to.fullPath) as string;
  let courseRole = getUrlQueryUseHash('courseRole',to.fullPath) as string;
  if(courseid != null && courseRole != null
    && courseid!=undefined && courseRole!=undefined
    && courseid.length>0 && courseRole.length>0)
  {
      postGetCourseUserInfo({courseid: courseid}).then((res:any)=>{
        getCourseHeaderInfo({ courseid: courseid }).then((res1) => {
          store.state.courseInfo = res1;
        });
        //获取浏览器的地址
        if(courseRole == '1' && res.courseRole == 0){
          location.href = "/ktpCourse";
        }else{
          if(res.courseRole == 0 && res.classending == 1 && res.canvisit==0){
            Dialog.alert({
              title: '系统提醒',
              message: '该课程已结课，老师已设置成不允许访问！',
            }).then((action:any)=>{
              let currentUrl = document.location.pathname;
              console.log('currentUrl:'+currentUrl);
              if(currentUrl == "/ktpCourse"){

              }else{
                location.href = "/ktpCourse";
              }
            })
            return;
          }
          //保存权限的设置
          let courseAuthName:string = "courseAuth:"+courseid;
          objCookie.setCookie(courseAuthName,JSON.stringify(res.authData), 1);
          //这里调用记录访问课程
          visitCourse({ courseid: courseid });
          next();
        }
      }).catch((e)=>{
        next();
      });
  }else{
    next();
  }

});

export default router;
